/**
 * This is a faux hook. But we're leaving it in this form for a reason.
 *
 * This will not work with server-side rendering (SSR), but rec.gov doesn't
 * currently use SSR, so this is not a problem.
 *
 * HOWEVER if we eventually need SSR support, this implementation will need to
 * change to something like the auto-id package in reach-ui
 * https://github.com/reach/reach-ui/tree/master/packages/auto-id
 */

let autoId = 0;
const genId = () => {
    if (autoId === Number.MAX_SAFE_INTEGER) {
        autoId = 0;
    }

    autoId += 1;

    return autoId;
};

export const useId = (idFromProps) => {
    const id = genId();

    return !idFromProps ? `use-id-${id}` : idFromProps;
};
